import { Base64 } from 'js-base64';

const { encode, decode } = Base64;

// base64加密
export const Base64Encryption = (content: string) => encode(content);

// base64解密
export const Base64Decryption = (content: string) => decode(content);
